import React from 'react';
import { Box } from '@material-ui/core';

// FIXME use proper type
interface SelectableBoxProps {
  children: React.ReactNode;
  onClick: () => void;
  isSelected: boolean;
}

const SelectableBox = ({
  isSelected,
  children,
  onClick,
}: SelectableBoxProps) => {
  const background = isSelected ? '#E8EFFF' : '#F4F5F5';
  const border = isSelected ? '#254FAB' : '#F4F5F5';
  const color = isSelected ? '#232F63' : '#585E5F';
  return (
    <Box
      bgcolor={background}
      borderColor={border}
      color={color}
      textAlign="center"
      border={1}
      borderRadius={8}
      flex={1}
      p={1}
      onClick={onClick}
      style={{
        cursor: 'pointer',
      }}
    >
      {children}
    </Box>
  );
};

export default SelectableBox;
